export default "__VITE_ASSET__4iywu4JO__"